import React from "react";

import { useTranslation } from "react-i18next";

export default function HomeServices() {
  const { t } = useTranslation("home", { keyPrefix: "services" });

  return (
    <section
      id="features"
      className="pt-[120px] pb-[50px]"
      style={{ backgroundColor: "hsl(0, 0%, 96%)" }}
    >
      <div className="container mx-auto px-4 max-w-[1320px]">
        <div className="flex flex-wrap mx-[-16px]">
          <div className="w-full px-4">
            <div
              className="
              mx-auto max-w-[570px] text-center mb-[100px]
              wow
              fadeInUp
            "
              data-wow-delay=".1s"
            >
              <h2
                className="
                text-black
                dark:text-white
                font-bold text-3xl
                sm:text-4xl
                md:text-[45px]
                mb-4
              "
              >
                {t("title")}
              </h2>
              <p
                className="
                text-body-color text-base
                md:text-lg
                leading-relaxed
                md:leading-relaxed
              "
              >
                {t("subTitle")}
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap mx-[-16px]">
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="mb-[70px] wow fadeInUp" data-wow-delay=".15s">
              <div
                className="
                w-[70px]
                h-[70px]
                flex
                items-center
                justify-center
                rounded-md
                bg-primary
                bg-opacity-10
                mb-10
                text-primary
              "
              >
                <svg
                  width="40"
                  height="41"
                  viewBox="0 0 40 41"
                  className="fill-current"
                >
                  <path
                    opacity="0.5"
                    d="M37.7778 40.2223H24C22.8954 40.2223 22 39.3268 22 38.2223V20.0001C22 18.8955 22.8954 18.0001 24 18.0001H37.7778C38.8823 18.0001 39.7778 18.8955 39.7778 20.0001V38.2223C39.7778 39.3268 38.8823 40.2223 37.7778 40.2223Z"
                  />
                  <path d="M23.2222 0C22.6699 0 22.2222 0.447715 22.2222 1V12.3333C22.2222 12.8856 22.6699 13.3333 23.2222 13.3333H39C39.5523 13.3333 40 12.8856 40 12.3333V0.999999C40 0.447714 39.5523 0 39 0H23.2222ZM0 39C0 39.5523 0.447715 40 1 40H16.7778C17.3301 40 17.7778 39.5523 17.7778 39V27.6667C17.7778 27.1144 17.3301 26.6667 16.7778 26.6667H1C0.447716 26.6667 0 27.1144 0 27.6667V39ZM0 21.2222C0 21.7745 0.447715 22.2222 1 22.2222H16.7778C17.3301 22.2222 17.7778 21.7745 17.7778 21.2222V0.999999C17.7778 0.447714 17.3301 0 16.7778 0H1C0.447716 0 0 0.447715 0 1V21.2222Z" />
                </svg>
              </div>
              <h3
                className="
                font-bold text-black
                dark:text-white
                text-xl
                sm:text-2xl
                lg:text-xl
                xl:text-2xl
                mb-5
              "
              >
                {t("service1.title")}
              </h3>
              <p
                className="
                text-body-color
                text-base
                leading-relaxed
                font-medium
                pr-[10px]
              "
              >
                {t("service1.description")}
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="mb-[70px] wow fadeInUp" data-wow-delay=".2s">
              <div
                className="
                w-[70px]
                h-[70px]
                flex
                items-center
                justify-center
                rounded-md
                bg-primary
                bg-opacity-10
                mb-10
                text-primary
              "
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  className="fill-current"
                >
                  <path
                    opacity="0.5"
                    d="M20.5914 34.2584C20.2394 34.5172 19.7603 34.5175 19.408 34.2593L4.19163 23.1079C3.8395 22.8498 3.36065 22.85 3.00873 23.1084L1.09802 24.5111C0.553731 24.9107 0.553731 25.7237 1.09802 26.1233L19.4082 39.5655C19.7604 39.824 20.2396 39.824 20.5918 39.5655L38.9029 26.1226C39.4469 25.7232 39.4473 24.9107 38.9036 24.5109L36.9701 23.0889C36.6177 22.8298 36.1378 22.8297 35.7854 23.0888L20.5914 34.2584Z"
                  />
                  <path d="M19.408 28.931C19.7603 29.1896 20.2396 29.1894 20.5918 28.9306L36.3556 17.3466L38.8979 15.4883C39.4437 15.0894 39.4446 14.275 38.8996 13.8749L20.5918 0.43445C20.2396 0.175911 19.7604 0.175913 19.4082 0.434452L1.09706 13.8774C0.553051 14.2767 0.552712 15.0892 1.09638 15.4891L3.62222 17.3466L19.408 28.931Z" />
                </svg>
              </div>
              <h3
                className="
                font-bold text-black
                dark:text-white
                text-xl
                sm:text-2xl
                lg:text-xl
                xl:text-2xl
                mb-5
              "
              >
                {t("service2.title")}
              </h3>
              <p
                className="
                text-body-color
                text-base
                leading-relaxed
                font-medium
                pr-[10px]
              "
              >
                {t("service2.description")}
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="mb-[70px] wow fadeInUp" data-wow-delay=".25s">
              <div
                className="
                w-[70px]
                h-[70px]
                flex
                items-center
                justify-center
                rounded-md
                bg-primary
                bg-opacity-10
                mb-10
                text-primary
              "
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  className="fill-current"
                >
                  <path
                    opacity="0.5"
                    d="M20 30C22.75 30 25 32.25 25 35C25 37.75 22.75 40 20 40C17.25 40 15 37.75 15 35C15 32.25 17.25 30 20 30ZM35 30C37.75 30 40 32.25 40 35C40 37.75 37.75 40 35 40C32.25 40 30 37.75 30 35C30 32.25 32.25 30 35 30ZM35 15C37.75 15 40 17.25 40 20C40 22.75 37.75 25 35 25C32.25 25 30 22.75 30 20C30 17.25 32.25 15 35 15Z"
                  />
                  <path d="M20 15C22.75 15 25 17.25 25 20C25 22.75 22.75 25 20 25C17.25 25 15 22.75 15 20C15 17.25 17.25 15 20 15ZM20 0C22.75 0 25 2.25 25 5C25 7.75 22.75 10 20 10C17.25 10 15 7.75 15 5C15 2.25 17.25 0 20 0ZM5 30C7.75 30 10 32.25 10 35C10 37.75 7.75 40 5 40C2.25 40 0 37.75 0 35C0 32.25 2.25 30 5 30ZM5 15C7.75 15 10 17.25 10 20C10 22.75 7.75 25 5 25C2.25 25 0 22.75 0 20C0 17.25 2.25 15 5 15ZM5 0C7.75 0 10 2.25 10 5C10 7.75 7.75 10 5 10C2.25 10 0 7.75 0 5C0 2.25 2.25 0 5 0ZM35 0C37.75 0 40 2.25 40 5C40 7.75 37.75 10 35 10C32.25 10 30 7.75 30 5C30 2.25 32.25 0 35 0Z" />
                </svg>
              </div>
              <h3
                className="
                font-bold text-black
                dark:text-white
                text-xl
                sm:text-2xl
                lg:text-xl
                xl:text-2xl
                mb-5
              "
              >
                {t("service3.title")}
              </h3>
              <p
                className="
                text-body-color
                text-base
                leading-relaxed
                font-medium
                pr-[10px]
              "
              >
                {t("service3.description")}
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="mb-[70px] wow fadeInUp" data-wow-delay=".1s">
              <div
                className="
                w-[70px]
                h-[70px]
                flex
                items-center
                justify-center
                rounded-md
                bg-primary
                bg-opacity-10
                mb-10
                text-primary
              "
              >
                <svg
                  width="40"
                  height="42"
                  viewBox="0 0 40 42"
                  className="fill-current"
                >
                  <path
                    opacity="0.5"
                    d="M31.8943 25.3303C34.1233 25.3303 36.1497 26.1409 37.5682 27.762L39.1464 26.1839C39.4614 25.8689 39.9999 26.092 39.9999 26.5374V32.936C39.9999 33.2121 39.7761 33.436 39.4999 33.436H33.1014C32.6559 33.436 32.4328 32.8974 32.7478 32.5825L35.5418 29.7885C34.5286 28.9779 33.3128 28.37 31.8943 28.37C29.0573 28.37 26.8282 30.599 26.8282 33.436C26.8282 36.273 29.0573 38.5021 31.8943 38.5021C33.3549 38.5021 34.6511 37.844 35.6345 36.8244C35.8406 36.6107 36.1187 36.4756 36.4155 36.4756H38.6535C39.0072 36.4756 39.2477 36.833 39.0881 37.1487C37.7427 39.8107 35.0781 41.5417 31.8943 41.5417C27.4361 41.5417 23.7886 37.8941 23.7886 33.436C23.7886 28.9779 27.4361 25.3303 31.8943 25.3303Z"
                  />
                  <path d="M18.7226 33.436C18.7226 31.3572 19.2513 29.4548 19.9799 27.7285C20.0541 27.5529 19.9264 27.3567 19.7358 27.3567C15.8856 27.3567 12.6433 24.1144 12.6433 20.2642C12.6433 16.414 15.8856 13.1717 19.7358 13.1717C23.586 13.1717 26.8283 16.414 26.8283 20.2642C26.8283 20.5105 27.3897 21.0054 27.6246 20.9313C28.9274 20.5206 30.2827 20.2642 31.8943 20.2642C32.775 20.2642 33.6557 20.4173 34.5364 20.5905C34.7422 20.6309 34.9339 20.4739 34.9339 20.2642C34.9339 19.8699 34.9339 19.3904 34.8787 18.9362C34.827 18.5117 34.9599 18.0636 35.3001 17.8045L38.9868 14.9955C39.3921 14.5902 39.3921 14.1849 39.1894 13.7797L35.1857 6.77316C35.153 6.71599 35.1272 6.65499 35.1021 6.59411C34.9143 6.13895 34.5848 6.08618 34.1135 6.08007C33.9863 6.07841 33.86 6.10354 33.7419 6.15079L29.3957 7.88927C29.0613 8.02302 28.6829 7.96367 28.3887 7.75599C27.6155 7.21023 26.7521 6.75466 25.8752 6.31262C25.5838 6.16573 25.3813 5.88702 25.3335 5.56423L24.6729 1.10574C24.6265 0.792572 24.6613 0.389935 24.3993 0.212245C24.2235 0.0930361 23.9828 0 23.7886 0H15.6829C15.3021 0 14.7424 0.35783 14.6762 0.73726C14.6678 0.785579 14.6661 0.834927 14.6589 0.883445L13.9492 5.67408C13.894 6.04692 13.6313 6.35205 13.2873 6.50604C12.4439 6.88359 11.673 7.42345 10.8193 7.89265C10.5647 8.03264 10.26 8.04143 9.99178 7.92966L5.73545 6.15619C5.61358 6.10541 5.48273 6.07832 5.35072 6.08016C4.8506 6.08715 4.49147 6.1485 4.13234 6.68719L0.0794975 13.7797C-0.123145 14.1849 0.0794976 14.5902 0.484782 14.9955L4.34631 17.9376C4.59456 18.1268 4.74261 18.4216 4.7079 18.7317C4.65068 19.243 4.53762 19.8101 4.53762 20.2642C4.53762 20.6648 4.53762 21.1534 4.59561 21.614C4.64767 22.0276 4.52563 22.4644 4.20164 22.7267L0.484782 25.7355C0.0794976 26.1408 0.0794978 26.5461 0.28214 26.9514L4.33498 34.0439C4.5154 34.4047 4.85644 34.4443 5.35811 34.4486C5.48532 34.4497 5.61152 34.4249 5.72964 34.3776L10.0758 32.6392C10.4102 32.5054 10.7887 32.5648 11.0829 32.7724C11.8561 33.3182 12.7195 33.7738 13.5964 34.2158C13.8878 34.3627 14.0903 34.6414 14.1381 34.9642L14.8616 39.8476C14.8688 39.8961 14.871 39.9453 14.8768 39.994C14.9222 40.3734 15.3145 40.7311 15.8856 40.7311H19.13C19.9191 40.7311 20.4065 39.8523 20.0627 39.1421C19.1998 37.3593 18.7226 35.4573 18.7226 33.436Z" />
                </svg>
              </div>
              <h3
                className="
                font-bold text-black
                dark:text-white
                text-xl
                sm:text-2xl
                lg:text-xl
                xl:text-2xl
                mb-5
              "
              >
                {t("service4.title")}
              </h3>
              <p
                className="
                text-body-color
                text-base
                leading-relaxed
                font-medium
                pr-[10px]
              "
              >
                {t("service4.description")}
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="mb-[70px] wow fadeInUp" data-wow-delay=".15s">
              <div
                className="
                w-[70px]
                h-[70px]
                flex
                items-center
                justify-center
                rounded-md
                bg-primary
                bg-opacity-10
                mb-10
                text-primary
              "
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  className="fill-current"
                >
                  <path
                    opacity="0.5"
                    d="M39 12C39.5523 12 40 12.4477 40 13V39C40 39.5523 39.5523 40 39 40H13C12.4477 40 12 39.5523 12 39V33C12 32.4477 12.4477 32 13 32H31C31.5523 32 32 31.5523 32 31V13C32 12.4477 32.4477 12 33 12H39Z"
                  />
                  <rect width="28" height="28" rx="1" />
                </svg>
              </div>
              <h3
                className="
                font-bold text-black
                dark:text-white
                text-xl
                sm:text-2xl
                lg:text-xl
                xl:text-2xl
                mb-5
              "
              >
                {t("service5.title")}
              </h3>
              <p
                className="
                text-body-color
                text-base
                leading-relaxed
                font-medium
                pr-[10px]
              "
              >
                {t("service5.description")}
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="mb-[70px] wow fadeInUp" data-wow-delay=".2s">
              <div
                className="
                w-[70px]
                h-[70px]
                flex
                items-center
                justify-center
                rounded-md
                bg-primary
                bg-opacity-10
                mb-10
                text-primary
              "
              >
                <svg
                  width="40"
                  height="45"
                  viewBox="0 0 40 45"
                  className="fill-current"
                >
                  <path
                    opacity="0.5"
                    d="M31.579 37.8948C28.6737 37.8948 26.3158 35.5369 26.3158 32.6317C26.3158 31.9159 26.4527 31.2306 26.7135 30.6015C26.7959 30.4027 26.7605 30.1711 26.6083 30.019L24.9997 28.4103C24.7766 28.1872 24.4043 28.2238 24.2487 28.4983C23.5588 29.7145 23.1579 31.125 23.1579 32.6317C23.1579 37.2843 26.9263 41.0527 31.579 41.0527V43.0035C31.579 43.449 32.1175 43.6721 32.4325 43.3571L35.9622 39.8273C36.1575 39.6321 36.1575 39.3155 35.9622 39.1202L32.4325 35.5905C32.1175 35.2755 31.579 35.4986 31.579 35.9441V37.8948ZM31.579 24.2106V22.2598C31.579 21.8144 31.0404 21.5913 30.7254 21.9063L27.1957 25.436C27.0004 25.6313 27.0004 25.9479 27.1957 26.1431L30.7254 29.6729C31.0404 29.9879 31.579 29.7648 31.579 29.3193V27.3685C34.4842 27.3685 36.8421 29.7264 36.8421 32.6317C36.8421 33.3474 36.7052 34.0328 36.4444 34.6618C36.362 34.8606 36.3974 35.0922 36.5496 35.2444L38.1582 36.853C38.3813 37.0762 38.7536 37.0396 38.9092 36.7651C39.5991 35.5488 40 34.1384 40 32.6317C40 27.9791 36.2316 24.2106 31.579 24.2106Z"
                  />
                  <path d="M18.9474 32.6316C18.9474 35.4705 19.8099 38.0969 21.2941 40.2796C21.7904 41.0094 21.3054 42.1053 20.4229 42.1053H4.21053C1.87368 42.1053 0 40.2316 0 37.8947V4.21053C0 1.89474 1.87368 0 4.21053 0H6.31579H16.8421H29.4737C31.7895 0 33.6842 1.87368 33.6842 4.21053V17.9544C33.6842 18.5032 33.1804 18.9474 32.6316 18.9474C25.0737 18.9474 18.9474 25.0737 18.9474 32.6316Z" />
                </svg>
              </div>
              <h3
                className="
                font-bold text-black
                dark:text-white
                text-xl
                sm:text-2xl
                lg:text-xl
                xl:text-2xl
                mb-5
              "
              >
                {t("service6.title")}
              </h3>
              <p
                className="
                text-body-color
                text-base
                leading-relaxed
                font-medium
                pr-[10px]
              "
              >
                {t("service6.description")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
